import { ProgressBarByStep } from "@/components/ProgressBar";

import { CAR_MAIN_PROGRESS_TITLES } from "../utils";

type Props = {
  orderNo: string;
  createdAt: string;
  totalAmount: number;
  statusText: string;
  statusDesc?: string;
  carProgressStep: number;
  onBack: () => void;
};

export default function CarOrderHeader({
  orderNo,
  createdAt,
  totalAmount,
  statusText,
  statusDesc,
  carProgressStep,
  onBack,
}: Props) {
  const progressTitles = [...CAR_MAIN_PROGRESS_TITLES];

  return (
    <div
      className="overflow-hidden sticky top-0 z-40"
      style={{
        background:
          "linear-gradient(145deg,#1A2238 0%,#2D3561 60%,#3D5A80 100%)",
      }}
    >
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute rounded-full"
          style={{
            width: 200,
            height: 200,
            top: -50,
            right: -30,
            background: "rgba(255,107,53,0.1)",
            filter: "blur(40px)",
          }}
        />
      </div>
      <div className="relative px-4 pb-4" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
        <div className="flex items-center gap-3 mb-2">
          <button
            type="button"
            onClick={onBack}
            className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
            style={{
              background: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            <i
              className="ri-arrow-left-line"
              style={{ fontSize: 18, color: "#fff" }}
            />
          </button>
          <div className="flex-1 min-w-0">
            <h1
              className="font-bold text-white leading-snug"
              style={{ fontSize: 15 }}
            >
              租车订单
              <span
                className="font-normal ml-1.5"
                style={{ fontSize: 12, color: "rgba(255,255,255,0.45)" }}
              >
                · 订单号：{orderNo}
              </span>
            </h1>
            <div
              className="mt-0.5"
              style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}
            >
              创建时间：{createdAt} | 总金额：¥
              {totalAmount.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
          <span
            className="text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap flex-shrink-0"
            style={{
              background: "rgba(255,255,255,0.12)",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.18)",
            }}
          >
            {statusText}
          </span>
        </div>
        {/* {statusDesc ? (
          <div
            className="ml-12 mb-1.5 text-xs"
            style={{ color: "rgba(255,255,255,0.55)" }}
          >
            {statusDesc}
          </div>
        ) : null} */}
        <ProgressBarByStep
          step={carProgressStep}
          titles={progressTitles}
          theme="blue"
        />
      </div>
    </div>
  );
}
